import Resource from '@/plugins/sdk/Resource'
import { DATETIME, UUID, ITEM } from '@/plugins/sdk/fields'
import AssetEvent from '@/plugins/sdk/resources/Asset/Event'
import File from '@/plugins/sdk/resources/File'

export default class extends Resource {
  static name = 'asseteventattachment'

  static get fields () {
    return {
      id: new UUID(),
      asset_event: new ITEM(AssetEvent),
      file: new ITEM(File),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME()
    }
  }
}
